import { getUser } from 'localStorage/authStorage';
import { CompanyRole } from 'models/companies/enums/companies.enums';
import { ProfileResponse } from 'models/auth/interfaces/auth.interface';
import { isAdminUser } from './admin-check';
import { isDriverUser } from './driver-check';

export const isClientUserFromProfile = (user: ProfileResponse): boolean =>
	user.company?.role === CompanyRole.CLIENT;

export const isClientUser = (): boolean => {
	const user = getUser();
	if (!user) return false;
	if (isDriverUser() || isAdminUser()) return false;
	return isClientUserFromProfile(user);
};
